import React from 'react';

/* Shimmer block — uses CSS variables for dark / light theming */
const ShimmerBox = ({ className = '', delay = '0s', style }: { className?: string; delay?: string; style?: React.CSSProperties }) => (
    <div
        className={`relative overflow-hidden rounded-lg ${className}`}
        style={{ backgroundColor: 'var(--v2-skeleton-base)', ...style }}
    >
        <div
            className="absolute inset-0 -translate-x-full animate-shimmer"
            style={{
                backgroundImage: `linear-gradient(90deg, transparent 0%, var(--v2-skeleton-shimmer) 45%, var(--v2-skeleton-shimmer) 55%, transparent 100%)`,
                animationDelay: delay,
            }}
        />
    </div>
);

/** Single stat-card skeleton — matches the compact StatCard layout */
export const KpiSkeleton: React.FC = () => (
    <div className="space-y-4">
        {/* Header row: icon + title + badge */}
        <div className="flex items-center gap-3">
            <ShimmerBox className="w-10 h-10 rounded-lg flex-shrink-0" delay="0s" />
            <div className="space-y-1.5 flex-1">
                <ShimmerBox className="h-4 w-28" delay="0.1s" />
                <ShimmerBox className="h-5 w-16 rounded-full" delay="0.15s" />
            </div>
        </div>
        {/* Chart area placeholder */}
        <div className="space-y-2 mt-1">
            <div className="flex items-end gap-8 justify-center" style={{ height: '70px' }}>
                <div className="flex flex-col items-center gap-1.5 flex-1">
                    <ShimmerBox className="h-2.5 w-12" delay="0.2s" />
                    <ShimmerBox className="w-full rounded-md" delay="0.25s" style={{ height: '40px' }} />
                    <ShimmerBox className="h-3 w-8" delay="0.3s" />
                </div>
                <div className="flex flex-col items-center gap-1.5 flex-1">
                    <ShimmerBox className="h-2.5 w-12" delay="0.35s" />
                    <ShimmerBox className="w-full rounded-md" delay="0.4s" style={{ height: '55px' }} />
                    <ShimmerBox className="h-3 w-8" delay="0.45s" />
                </div>
            </div>
        </div>
    </div>
);

export default KpiSkeleton;
